
namespace Matrix.Common {

    export class BookmarksDropdown {

        private dropdownMenu: JQuery;

        constructor(container: JQuery) {

            if (!container.length)
                return;

            container.on('shown.bs.dropdown', e => {
                container.find('input[type=text]').focus();
            });

            this.dropdownMenu = container.children('.dropdown-menu');

            var favName = container.find('input[type=text]');

            container.find('button.save-bookmark-button').click(() => {
                var name = Q.trimToNull(favName.val());
                if (!name) {
                    Q.notifyWarning("Please write a bookmark name!");
                    return;
                }

                var bookmarks = this.getFavorites();
                bookmarks[name] = window.location.href;
                this.saveFavorites(bookmarks);
                Q.notifySuccess("Current page is saved with name \"" + name + "\".");
                favName.val('');
                this.populateFavorites();
            });

            this.dropdownMenu.on('click', 'i.remove-bookmark', e => {
                var name = $(e.target).closest('.dropdown-item').find('a').text();
                var bookmarks = this.getFavorites();
                delete bookmarks[name];
                this.saveFavorites(bookmarks);
                this.populateFavorites();
                Q.notifyWarning("Bookmark with name \"" + name + "\" is deleted.");
            });

            this.populateFavorites();
        }

        private populateFavorites() {
            var bookmarks = this.getFavorites();

            this.dropdownMenu.children('.dropdown-item').remove();

            var keys = Object.keys(bookmarks).sort();
            for (var k of keys) {
                $('<div class="dropdown-item"><a href="' + Q.attrEncode(bookmarks[k]) +
                    '">' + Q.htmlEncode(k) + '</a><i class="remove-bookmark fa fa-trash-o pull-right"></i></div>')
                    .appendTo(this.dropdownMenu);
            }
        }

        private saveFavorites(bookmarks) {
            var storage = new UserPreferenceStorage();
            var key = "FavoritePages";
            storage.setItem(key, JSON.stringify(bookmarks));
        }

        private getFavorites() {
            var storage = new UserPreferenceStorage();
            var key = "FavoritePages";
            return JSON.parse(storage.getItem(key) || "{}") || {};
        }
    }
}